/**
 * Sotreq Search Initialization
 * This module handles the Algolia InstantSearch initialization
 * to prevent re-declaration errors with Turbo navigation
 */

function initializeSotreqSearch() {
  // Only initialize once per page load
  if (window.sotreqSearchInitialized) {
    return;
  }

  // Check if required elements and libraries exist
  const searchboxElement = document.getElementById('searchbox');
  const hitsElement = document.getElementById('hits');
  
  if (!searchboxElement || !hitsElement) {
    return;
  }

  if (typeof algoliasearch === 'undefined' || typeof instantsearch === 'undefined') {
    return;
  }

  try {
    const sotreqSearchClient = algoliasearch('C8UOQE50UL', '6cde5932607064642b74439944b39e33');
    const sotreqSearch = instantsearch({
      indexName: 'SearchableSotreq',
      onStateChange: ({ uiState, setUiState }) => {
        const nohitsElement = document.getElementById('nohits');
        const hashitsElement = document.getElementById('hashits');
        
        if (!nohitsElement || !hashitsElement) {
          return;
        }

        console.log(uiState.SearchableSotreq.query);
        if (typeof uiState.SearchableSotreq.query === 'undefined') {
          nohitsElement.style.display = 'flex';
          hashitsElement.style.display = 'none';
        } else if (uiState.SearchableSotreq.query !== "") {
          nohitsElement.style.display = 'none';
          hashitsElement.style.display = 'block';
        }
        setUiState(uiState);
      },
      numberLocale: 'pt',
      searchClient: sotreqSearchClient
    });

    sotreqSearch.addWidget(
      instantsearch.widgets.searchBox({
        container: "#searchbox",
        placeholder: 'Buscar...',
        autofocus: true,
        searchAsYouType: true,
        showReset: true,
        showLoadingIndicator: true,
        cssClasses: {
          root: 'MyCustomSearchBox',
          form: 'input-group',
          input: [
            'form-control',
            'rounded-0'
          ],
          submit: [
            'btn',
            'btn-dark'
          ],
          submitIcon: 'yellowsearch',
          reset: [
            'btn',
            'btn-outline-secondary'
          ],
        },
      })
    );

    sotreqSearch.addWidget(
      instantsearch.widgets.infiniteHits({
        container: '#hits',
        cssClasses: {
          loadMore: 'hidden',
          root: 'MyCustomHits',
          list: ['list-group list-group-flush'],
          item: ['list-group-item']
        },
        templates: {
          item: (item) => `<a href="${item.url}" class="notalink">
            <h5 class="mb-1">${item.title}</h5>
          </a>`,
          empty: `Nenhum resultado encontrado para <q>{{ query }}</q>`,
          showMoreText: 'Mostrar mais',
        },
        showMoreLimit: 12,
      })
    );

    sotreqSearch.start();
    window.sotreqSearchInitialized = true;
    window.sotreqSearchInstance = sotreqSearch;
  } catch (error) {
    console.error('Error initializing Sotreq search:', error);
  }
}

// Initialize on first load
document.addEventListener('DOMContentLoaded', initializeSotreqSearch);

// Handle Turbo navigation
document.addEventListener('turbo:load', () => {
  // Reset initialization flag if we're navigating away from pages with the search modal
  if (!document.getElementById('staticBackdrop')) {
    window.sotreqSearchInitialized = false;
    window.sotreqSearchInstance = null;
  } else {
    // Re-initialize if we're on a page with the search modal
    initializeSotreqSearch();
  }
});

// Clean up on Turbo before-visit to prevent issues
document.addEventListener('turbo:before-visit', () => {
  if (window.sotreqSearchInstance && window.sotreqSearchInstance.dispose) {
    try {
      window.sotreqSearchInstance.dispose();
    } catch (error) {
      console.error('Error disposing search instance:', error);
    }
  }
  window.sotreqSearchInitialized = false;
});
